import axios from 'axios';

// internal
import { endpoint, headers } from '@app/utils/service';
import {
  FetchZone,
  FetchZoneSelect,
  FetchCreate,
  FetchZoneWithId,
  FETCHZoneDelete,
} from '@app/typings/services/zone';

export const fetchZone: FetchZone = (brand, project, brief) => {
  return axios({
    url: endpoint(`/zones`),
    method: 'GET',
    params: {
      brief,
      brandId: brand,
      projectId: project,
      limit: 0,
    },
    ...headers(),
  });
};

export const fetchZoneWithId: FetchZoneWithId = (id) => {
  return axios({
    url: endpoint(`/zones/${id}`),
    ...headers(),
  });
};

export const fetchCreate: FetchCreate = (name, brand, project) => {
  return axios({
    url: endpoint(`/zones`),
    method: 'POST',
    data: {
      name,
      branId: brand,
      projectId: project,
    },
    ...headers(),
  });
};

export const fetchZoneSelect: FetchZoneSelect = (brand, project) => {
  return fetchZone(brand, project, true);
};

export const fetchZoneDelete: FETCHZoneDelete = (id) => {
  return axios({
    url: endpoint(`/zones/${id}`),
    method: 'DELETE',
    ...headers(),
  });
};
